import { createContext } from "react";

export interface PersistedSession {
  token: string;
  user_id: string;
  username: string;
  role: "admin" | "user";
}

export type AuthState =
  | { status: "loading" }
  | { status: "anonymous" }
  | { status: "authenticated"; session: PersistedSession };

export interface AuthContextValue {
  state: AuthState;
  login: (username: string, password: string) => Promise<void>;
  /** Establish session from OA callback LoginResponse fields. */
  loginWithSession: (session: PersistedSession) => void;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
